var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 23C15.0019 23 13.691 22.6724 12.5674 22.0173C11.4438 21.3622 10.5684 20.448 9.94101 19.2747C9.31367 18.1013 9 16.7324 9 15.168V8.832C9 7.26755 9.31367 5.89867 9.94101 4.72533C10.5684 3.552 11.4438 2.63778 12.5674 1.98267C13.691 1.32755 15.0019 1 16.5 1C17.9981 1 19.309 1.32755 20.4326 1.98267C21.5562 2.63778 22.4316 3.552 23.059 4.72533C23.6863 5.89867 24 7.26755 24 8.832V15.168C24 16.7324 23.6863 18.1013 23.059 19.2747C22.4316 20.448 21.5562 21.3622 20.4326 22.0173C19.309 22.6724 17.9981 23 16.5 23ZM16.5 19.216C17.1742 19.216 17.7828 19.0498 18.3258 18.7173C18.8689 18.3849 19.2996 17.9351 19.618 17.368C19.9363 16.8009 20.0955 16.1653 20.0955 15.4613V8.50933C20.0955 7.80533 19.9363 7.16978 19.618 6.60267C19.2996 6.03556 18.8689 5.58578 18.3258 5.25333C17.7828 4.92089 17.1742 4.75467 16.5 4.75467C15.8258 4.75467 15.2172 4.92089 14.6742 5.25333C14.1311 5.58578 13.7004 6.03556 13.382 6.60267C13.0637 7.16978 12.9045 7.80533 12.9045 8.50933V15.4613C12.9045 16.1653 13.0637 16.8009 13.382 17.368C13.7004 17.9351 14.1311 18.3849 14.6742 18.7173C15.2172 19.0498 15.8258 19.216 16.5 19.216Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.93312 22.5599V5.78127L0 8.21594V3.81594L3.93312 1.43994H7.98279V22.5599H3.93312Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg10);
export default __webpack_public_path__ + "static/media/10.df5b330170ad46c0ab5e48794b632edc.svg";
export { ForwardRef as ReactComponent };